<template>
  <div>
    <!--<v-chip color="secondary" v-if="tour.name !== ''">{{ tour.name }}</v-chip>-->
    <v-chip v-for="city in tour.namedCities" class="city" :key="city">{{ city }}</v-chip>
  </div>
</template>

<script>
export default {
  name: 'TourName',
  props: ['tour']
}
</script>



// WEBPACK FOOTER //
// src/components/TourName.vue